import React from 'react';
import { Provider, connect } from 'react-redux';
import { compose, lifecycle, withProps } from 'recompose';
import { get } from 'lodash';

import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import withLoader from './modules/app/withLoader';
import Loader from './components/loader';
import Login from './modules/login';

import { loadUser } from './modules/login/_api';
import { attributes, getQrCodeSettings } from './modules/app/_api.js';

import { SnackbarProvider } from 'notistack';
import Main from './Main';

const enhance = compose(
  withLoader,
  connect(
    (state) => ({
      isLoading: get(state, 'app.isLoading'),
      isMiniMode: get(state, 'app.miniMode'),
      isLoggedIn: get(state, 'user.username'),
    }),
    { loadUser, attributes, getQrCodeSettings }
  ),
  withProps(({ isMiniMode }) => {
    let customTheme = {};
    if (isMiniMode) {
      customTheme = {
        typography: {
          fontSize: 12,
        },
      };
    }
    return {
      customTheme,
    };
  }),
  lifecycle({
    async componentDidMount() {
      const { loadUser, attributes, getQrCodeSettings, isMiniMode } = this.props;
      if (isMiniMode) {
        document.body.classList.add('is-mini-mode');
      }
      const resp = await loadUser();
      if (resp) {
        await attributes();
        await getQrCodeSettings();
      }

      this.intervalId = setInterval(loadUser, 60 * 1000);
    },
    componentWillUnmount() {
      clearInterval(this.intervalId);
    },
  })
);

export default enhance(({ store, isLoading, isLoggedIn, customTheme }) => (
  <Provider store={store}>
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      <React.Fragment>
        <MuiThemeProvider theme={createMuiTheme(customTheme)}>
          <Loader loading={isLoading} />
          {isLoggedIn ? (
            <React.Fragment>
              <CssBaseline />
              <Main />
            </React.Fragment>
          ) : (
            <Login />
          )}
        </MuiThemeProvider>
      </React.Fragment>
    </SnackbarProvider>
  </Provider>
));



// WEBPACK FOOTER //
// ./src/App.js